<nav class="navbar navbar-expand-md bg-primary navbar-dark" >
    <div class="container-fluid">
        <a class="navbar-brand" href="#">
            <img class="logo" src="../../../assets/imgs/logo_inv.png">
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#userInformation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse text-center justify-content-end" id="userInformation">
            <ul class="navbar-nav mr-2">
                <li class="nav-item text-white icon-link" routerLink="/dashboard">
                    <i class="fas fa-home"></i>
                </li>
            </ul>
            <ul class="nav navbar-nav navbar-right">
                <li></li>
                <li class="dropdown text-white">
                    <a class="btn navbar-btn ms-2 text-white btn-orange usrName dropdown-toggle" data-bs-toggle="dropdown">
                        <i class="fas fa-user"></i>&nbsp;&nbsp;&nbsp;{{userInfo.displayname}}
                    </a>
                    <ul class="dropdown-menu">
                        <li class="p-2">
                            <img class="img-fluid d-block mx-auto rounded-circle usrimage" src="../../../assets/imgs/no_avatar.png" >
                            <div class="text-center mt-2">{{userInfo.displayname}}</div>
                            <div class="text-muted text-center usrDepartament">{{userInfo.title}}</div>
                            <div class="text-muted text-center usrDepartament">{{userInfo.department}}</div>
                            <div class="text-center usrEmail mt-2">{{userInfo.mail}}</div>
                            <div class="text-center usrEmail">{{userInfo.telephonenumber}}</div>
                            <div class="text-center w-100 mt-2"><button class="btn btn-primary w-100" (click)="logOff()"><i class="fas fa-sign-out-alt"></i>&nbsp;&nbsp;&nbsp;Sair</button></div>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</nav>
<div class="p-0 pt-0">
    <div class="container-fluid">
        <div class="row p-0 m-0">
            <div class="col-md-12 col-12 p-0 m-0 text-right">
                <div class="usrUnidade">Unidade: <span>{{userInfo.physicaldeliveryofficename}}</span></div>
            </div>
        </div>
    </div>
</div>